import { NgClass } from '@angular/common';
import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';

import * as _ from 'underscore';

import { RaceTimer } from '../../common/racing/race-timer';
import { LocaleDirective } from '../../directives/locale.directive';

@Component({
    selector: 'race-timer',
    templateUrl: 'race-timer.component.html',
    styleUrls: ['race-timer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, LocaleDirective],
})
export class RaceTimerComponent extends RaceTimer implements OnInit, OnDestroy, OnChanges {
    ngOnInit(): void {
        this.init();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.event) {
            this.init();
        }
    }

    ngOnDestroy(): void {
        this.clearTimers();
    }
}
